<style lang="stylus">
@import '../../../../stylesheet/variable.styl'
.preorder
    .coupons
        position relative
        font-size 15px
        background-color #fff
        height 50px
        line-height 50px
        border-bottom none
        clear both
        &:after
            etBottomLine()
        .coupon-label
            transform: translateX(-3.5px);
            float left
            overflow: hidden;
            height: 50px;
            div
                float: right;
            img
              width 20px;
              height 28px;
              margin 10px 3px;
        div:not(:last-of-type)
            display block
            float right
            margin-right 24px
            font-size 14px
            color rgb(25, 26, 27)
</style>
<template>
    <div class="coupons" @click="toChooseCoupon">
        <div class=" item">
            <div v-if="hasSelectedCoupon">
                <span>
                    <small>-<small class="icon-yen">&yen;</small></small>{{selectedCoupon.deductionInfo.deductionValue |price2}}
                </span>
                <icon class="arrow">quanju_liebiaojiantou</icon>
            </div>
            <div v-else>
                <span>
                    {{matchCouponNum}}张券可用
                </span>
                <icon class="arrow">quanju_liebiaojiantou</icon>
            </div>
            <div class="coupon-label">
                <div style="margin-left:8px;">现金券</div>
                <img class="coupon-icon" src="../../../../image/preorder/coupon.png">
            </div>
        </div>
    </div>

</template>
<script>
    import { mapState, mapActions } from 'vuex'
    import icon from '../../../components/icon'
    import op from 'object-path'
    export default {
        props: ['thirdOrderId'],
        data() {
            return {

            }
        },
        components: {
            icon
        },
        computed: {
            ...mapState({
                matchCouponNum: state => state.preorder.orderMatchCouponNum,
                selectedCoupon: state => state.preorder.selectedCoupon
            }),
            hasSelectedCoupon() {
                if(op(this.selectedCoupon).get('epayList.length') > 0) {
                    return true
                }else {
                    return false
                }
            },

        },
        methods:{
            toChooseCoupon() {
                this.$router.push({
                    name: 'preorderCoupon',
                })
            }
        }
    }
</script>
